import {ClockLogoProps, positions, ScrewPosition} from './ClockLogo.model';
import screw from '../../../assets/screw.svg';
import './ClockLogo.scss';

const RectangularClockWrapper = ({ children }: ClockLogoProps) => {
  const Screw = ({ x, y, angle }: ScrewPosition) => (
    <img
      className="rectangular_wrapper__screw"
      src={screw}
      alt="screw"
      style={{
        left: x,
        top: y,
        transform: `translate(-50%, -50%) rotate(${angle}deg)`,
      }}
    />
  );

  return (
    <div className='rectangular_wrapper'>

      {positions.map((pos, idx) => (
        <Screw key={idx} x={pos.x} y={pos.y} angle={pos.angle} />
      ))}

      {children}
    </div>
  );
};

export default RectangularClockWrapper;
